import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const {FiHelpCircle, FiChevronDown} = FiIcons;

const FAQS = [
  {
    question: 'What is the Green Monster scoreboard?',
    answer: 'Green Monster is an independent Boston Red Sox website with live scores, line scores, schedules, standings, player statistics, game recaps, team analytics, franchise history, news, and video highlights.'
  },
  {
    question: 'How often are live Red Sox scores updated?',
    answer: 'Live game data refreshes approximately every 10 seconds while a Red Sox game is in progress. At other times, the main scoreboard refreshes approximately every 30 seconds.'
  },
  {
    question: 'Where does the scoreboard data come from?',
    answer: 'Scores, schedules, standings, rosters, player statistics, game feeds, box scores, news, and highlights are obtained from official MLB data services.'
  },
  {
    question: 'Can I view previous Red Sox games?',
    answer: 'Yes. Game History provides completed games by season, including final scores, opponents, venues, box scores, inning breakdowns, scoring timelines, pitching decisions, and top performers when available.'
  },
  {
    question: 'Does the site include player and team analytics?',
    answer: 'Yes. The site includes player profiles, career and season metrics, batting and pitching leaders, performance trends, home and away splits, opponent records, run differential, and other team analytics.'
  },
  {
    question: 'Can I receive live score notifications?',
    answer: 'Yes. During live games, supported browsers can enable score alerts from the scoreboard. Browser notification permission is required, and alerts remain controlled by your browser.'
  },
  {
    question: 'Is Green Monster affiliated with the Boston Red Sox or MLB?',
    answer: 'No. Green Monster is an independent informational website and is not affiliated with, endorsed by, or sponsored by the Boston Red Sox or Major League Baseball.'
  }
];

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: FAQS.map(({question, answer}) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer
    }
  }))
};

const FAQSection = () => (
  <section
    aria-labelledby="faq-heading"
    className="border-2 border-[#658d71] bg-[rgba(0,0,0,0.05)]"
  >
    <script type="application/ld+json">
      {JSON.stringify(faqSchema)}
    </script>

    <div className="flex items-center gap-3 border-b-2 border-[#658d71] p-3 sm:p-5">
      <SafeIcon icon={FiHelpCircle} size={19} className="text-[#a9c9b1]" />
      <div>
        <h2
          id="faq-heading"
          className="text-xl font-black uppercase tracking-widest text-[#d8ceb3] sm:text-3xl"
        >
          Frequently Asked Questions
        </h2>
        <p className="mt-0.5 text-[10px] font-bold uppercase tracking-widest text-[#658d71]">
          Green Monster scoreboard, data, features, and coverage
        </p>
      </div>
    </div>

    <div className="grid grid-cols-1 gap-px bg-[rgba(101,141,113,0.35)] lg:grid-cols-2">
      {FAQS.map(({question, answer}, index) => (
        <details
          key={question}
          className="group bg-[#31583e] p-4 open:bg-[#386646] sm:p-5"
          open={index === 0}
        >
          <summary className="flex cursor-pointer list-none items-center justify-between gap-4 text-left">
            <span className="text-xs font-black uppercase tracking-wider text-white sm:text-sm">
              {question}
            </span>
            <SafeIcon
              icon={FiChevronDown}
              size={15}
              className="shrink-0 text-[#d8ceb3] transition-transform duration-200 group-open:rotate-180"
            />
          </summary>
          <p className="mt-3 max-w-2xl border-t border-[rgba(101,141,113,0.45)] pt-3 text-xs leading-relaxed text-[#a9c9b1]">
            {answer}
          </p>
        </details>
      ))}
    </div>
  </section>
);

export default FAQSection;